import { render } from "./terminal-sequence-card.vue?vue&type=template&id=58118512&scoped=true"
import script from "./terminal-sequence-card.vue?vue&type=script&lang=js"
export * from "./terminal-sequence-card.vue?vue&type=script&lang=js"

import "./terminal-sequence-card.vue?vue&type=style&index=0&id=58118512&scoped=true&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58118512"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBadge,QLinearProgress,QDialog,QCardSection,QSpace,QBtn});qInstall(script, 'directives', {ClosePopup});
